import React from 'react';
import { CircularProgressbarWithChildren, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import PropTypes from 'prop-types';

const CircularProgressBar = (props) => (
  <CircularProgressbarWithChildren {...props} styles={buildStyles(props.styles)}>
    {props.children}
  </CircularProgressbarWithChildren>
);

export default CircularProgressBar;

CircularProgressBar.propTypes = {
  /** Completion value of the progressbar, from 0 to maxValue. */
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /** Maximum value of the progressbar.*/
  maxValue: PropTypes.number,
  /** Width of circular line relative to total width of component, a value from 0-100. */
  strokeWidth: PropTypes.number,
  /** Number from 0-1 representing ratio of the full circle diameter the progressbar should use. */
  circleRatio: PropTypes.number,
  /** Object allowing customization of styles of each svg subcomponent (root, trail, path, text, background) */
  styles: PropTypes.shape({
    rotation: PropTypes.number,
    strokeLinecap: PropTypes.string,
    textSize: PropTypes.string,
    pathTransitionDuration: PropTypes.number,
    pathColor: PropTypes.string,
    textColor: PropTypes.string,
    trailColor: PropTypes.string,
    backgroundColor: PropTypes.string,
  }),
};

CircularProgressBar.defaultProps = {
  value: 10000,
  maxValue: 10000,
  strokeWidth: 6,
  circleRatio: 1,
  styles: {
    rotation: 0,
    pathColor: '#00857c',
    trailColor: '#EDEDED',
  },
};
